import PointCutDialog from './pointCutDialog.container'

export default PointCutDialog